<div class="loading-spinner">
  <div class="inner-container">
    <div class="inner-loader"></div>
    <div class="inner-loader"></div>
    <div class="inner-loader"></div>
    <div class="inner-loader"></div>
    <div class="loading">Loading</div>
  </div>
</div>
